module.exports = __webpack_public_path__ + "img/arrow.ea919f86.svg";